import { T } from "../lib/fc3i18n";
import React from "react";
import { usePremium } from "./pages";
import FitnessHub from "../fitness/FitnessHub";
export default function AppFitness() {
  const {
    isPremium,
    loading
  } = usePremium();
  return <div className="max-w-[1180px] mx-auto" data-testid="app-fitness">
      <p className="text-[12px] font-extrabold uppercase tracking-widest text-[#E0306F]">{T("FemCare Fitness")}</p>
      <h1 className="mt-1 text-[30px] md:text-[38px] font-extrabold text-[#1E1A2B] tracking-tight">{T("Move in a way that fits your cycle")}</h1>
      <p className="mt-2 mb-10 text-[16px] text-[#5F5A70] max-w-2xl">
        {loading ? T("Checking your plan…") : isPremium ? T("Your full Fitness library is unlocked with Premium. Pick your phase or a category and press play.") : T("Free workouts are open to everyone. Join Premium to unlock the full library.")}
      </p>
      <FitnessHub unlocked={!loading && isPremium} lockedHref="/app/subscription" />
    </div>;
}